import { useCallback } from 'react';
import { message } from 'antd';
import wsuiApi from '@api/wsuiApi';
import { useVerifyModalStore } from '@store/verifyModalStore';

/** 合规信息接口 */
interface IHeguiInfo {
    url?: string;
    bos_key?: string;
    hegui_info?: string;
    need_hegui?: boolean;
}

/**
 * 合规校验跳转 Hook
 * 处理引用文献点击时的合规校验流程
 *
 * 流程：
 * 1. need_hegui=false：直接跳转
 * 2. need_hegui=true：调用 hegui_verify 接口
 *    - 未登录：HTTP 拦截器已处理跳转登录页
 *    - is_need_auth=true：显示全局认证弹窗
 *    - is_need_auth=false：跳转返回的 url
 */
export function useHeguiNavigate() {
    const showVerifyModal = useVerifyModalStore((state) => state.showVerifyModal);

    const navigate = useCallback(
        async (doc: IHeguiInfo) => {
            // 不需要校验，直接跳转
            if (!doc.need_hegui) {
                if (doc.url) {
                    window.open(doc.url, '_blank');
                }
                return;
            }

            // 调用合规校验接口
            const { errno, data } = await wsuiApi.heguiVerify({
                bosKey: doc.bos_key ?? '',
                conds: doc.hegui_info ?? '',
                businessType: 'doctor_youyi'
            });

            // 未登录：HTTP 拦截器已处理跳转登录页，无需额外处理
            if (errno !== 0 || !data) {
                return;
            }

            const { auth, url, is_blocked } = data;

            // 文献被屏蔽，显示提示
            if (is_blocked) {
                message.warning('本文献维护中，暂不可查看');
                return;
            }

            if (auth.is_need_auth) {
                // 需要实名认证，显示全局认证弹窗
                showVerifyModal();
            } else if (url) {
                // 合规通过，跳转
                window.open(url, '_blank');
            }
        },
        [showVerifyModal]
    );

    return { navigate };
}